import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { suscribe } from "../api/dashboard";
const publicVapidKey =
  "BOuHRwWTwxWNkpgu68L7bkKQP-20xyO8-s2doI4NnUuYTrVjoO3iOmi--H4zQ0k9Dpihu-o0_RZ-LW588INRwm0"; // Tu clave pública

const ActivityLogTable = ({
  logs = [],
  propertyId,
  setView,
  setReservationToShow,
}) => {
  const subscribeToNotifications = async () => {
    try {
      // 1. Registrar el Service Worker
      const registration = await navigator.serviceWorker.register(
        "/service-worker.js"
      );
      console.log("✅ Service Worker registrado.");

      // 2. Pedir permiso
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        alert("Permiso para notificaciones denegado.");
        return;
      }

      // 3. Suscribirse
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });

      // 4. Extraer datos (incluye endpoint + keys)
      const subscriptionData = subscription.toJSON();

      // 5. Enviar al backend
      await suscribe({
        ...subscriptionData,
        propertyId: propertyId,
      });

      alert("✅ Suscripción enviada al servidor.");
    } catch (error) {
      console.error("❌ Error al suscribirse:", error);
      alert("❌ No se pudo completar la suscripción.");
    }
  };

  // 🔧 Utilidad para codificar la clave pública VAPID
  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = atob(base64);
    return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
  };

  return (
    <Box
      sx={{
        bgcolor: "rgba(144, 58, 242, 0.15)", // Violeta Ubika con transparencia
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        onClick={subscribeToNotifications}
        sx={{ m: 1 }}
      >
        Activar notificaciones push
      </Button>

      <TableContainer
        sx={{
          bgcolor: "rgba(144, 58, 242, 0)", // Violeta Ubika con transparencia
        }}
        component={Paper}
      >
        <Table>
          <TableHead
            sx={{
              bgcolor: "rgba(243, 239, 247, 0.6)", // Violeta Ubika con transparencia
            }}
          >
            <TableRow>
              <TableCell>Acción</TableCell>
              <TableCell>Realizado por</TableCell>
              <TableCell>Monto</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Fecha</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.length > 0 ? (
              logs.map((log, idx) => (
                <TableRow
                  key={idx}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    console.log("🪵 Log seleccionado:", log);
                    if (log.reservationId) {
                      setReservationToShow(log.reservationId);
                      setView("reserva_unica");
                    }
                  }}
                >
                  <TableCell>{log.action}</TableCell>
                  <TableCell>{log.performedBy}</TableCell>
                  <TableCell>
                    {log.amount ? `$${log.amount.toLocaleString()}` : "-"}
                  </TableCell>
                  <TableCell>{log.description || "-"}</TableCell>
                  <TableCell>
                    {new Date(log.createdAt).toLocaleString("es-CL")}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No hay actividad registrada.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ActivityLogTable;
